var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIconReport(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "20px",
    height: "20px",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Artboard") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Artboard",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "icon_report",
    transform: "translate(2.000000, 2.000000)",
    fill: "#A3B3C5",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M12.8,8.08 L12.8,2.4 C12.8,1.9581722 12.4418278,1.6 12,1.6 L9.6,1.6 L9.6,0.8 C9.6,0.3581722 9.2418278,0 8.8,0 L4,0 C3.5581722,0 3.2,0.3581722 3.2,0.8 L3.2,1.6 L0.8,1.6 C0.3581722,1.6 0,1.9581722 0,2.4 L0,15.2 C0,15.6418278 0.3581722,16 0.8,16 L12,16 C14.0550124,16.0020653 15.7772426,14.4466061 15.9837688,12.4019968 C16.1902949,10.3573875 14.8139142,8.4889374 12.8,8.08 Z M14.256,11.2 L12.8,11.2 L12.8,9.744 C13.4794527,9.98590579 14.0140942,10.5205473 14.256,11.2 Z M4.8,1.6 L8,1.6 L8,3.2 L4.8,3.2 L4.8,1.6 Z M1.6,3.2 L3.2,3.2 L3.2,4 C3.2,4.4418278 3.5581722,4.8 4,4.8 L8.8,4.8 C9.2418278,4.8 9.6,4.4418278 9.6,4 L9.6,3.2 L11.2,3.2 L11.2,8.08 C9.33733498,8.46021486 7.99961199,10.0989255 8,12 C8,12.8654809 8.28071149,13.7076153 8.8,14.4 L1.6,14.4 L1.6,3.2 Z M12,14.4 C10.8383961,14.3909878 9.8499928,13.5513499 9.65328109,12.4064878 C9.45656938,11.2616256 10.1080245,10.1402252 11.2,9.744 L11.2,12 C11.2,12.4418278 11.5581722,12.8 12,12.8 L14.256,12.8 C13.9178014,13.756583 13.0146039,14.3971485 12,14.4 Z",
    id: "Shape"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.4,6.4 L3.2,6.4 C2.7581722,6.4 2.4,6.7581722 2.4,7.2 C2.4,7.6418278 2.7581722,8 3.2,8 L6.4,8 C6.8418278,8 7.2,7.6418278 7.2,7.2 C7.2,6.7581722 6.8418278,6.4 6.4,6.4 Z",
    id: "Path"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.4,9.6 L3.2,9.6 C2.7581722,9.6 2.4,9.9581722 2.4,10.4 C2.4,10.8418278 2.7581722,11.2 3.2,11.2 L6.4,11.2 C6.8418278,11.2 7.2,10.8418278 7.2,10.4 C7.2,9.9581722 6.8418278,9.6 6.4,9.6 Z",
    id: "Path"
  }))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconReport);
export default __webpack_public_path__ + "static/media/icon_report.de4bfe53.svg";
export { ForwardRef as ReactComponent };